import { ApiResponse } from 'apisauce'
import { call, put, select } from 'redux-saga/effects'

import api from 'src/services/api'

import { ApplicationState } from 'src/core/store'
import { ClientNotifyCatch } from 'src/config/bugsnag'

import * as Actions from './actions'
import {
  ResponseDataChangePassword,
  ResponseDataMe,
  ResponseDataOrganization,
  ResponseDataPolicies,
  ResponseDataQrCode
} from './types'

export function* changePassword({
  payload: { password }
}: ReturnType<typeof Actions.changePassword>) {
  try {
    const { user } = yield select((state: ApplicationState) => state.me)

    const { ok }: ApiResponse<ResponseDataChangePassword> = yield call(
      api.post,
      `/users/${user.user_id}/password`,
      {
        user: {
          password_new: password
        }
      }
    )

    if (ok) {
      yield put(Actions.changePasswordSuccess())
      return
    }

    yield put(Actions.changePasswordFailure())
  } catch (err) {
    ClientNotifyCatch('Saga changePassword', err)
    yield put(Actions.changePasswordFailure())
  }
}

export function* generateQRCode() {
  try {
    const { data, ok }: ApiResponse<ResponseDataQrCode> = yield call(
      api.get,
      'users/me/devices/credentials'
    )

    if (ok) {
      yield put(Actions.generateQRCodeSuccess(data.qrCode))
      return
    }

    yield put(Actions.generateQRCodeFailure())
  } catch (err) {
    ClientNotifyCatch('Saga generateQRCode', err)
    yield put(Actions.generateQRCodeFailure())
  }
}

export function* getMe() {
  try {
    const { data, ok }: ApiResponse<ResponseDataMe> = yield call(
      api.get,
      'users/me'
    )

    if (ok) {
      yield put(Actions.getMeSuccess(data.user))
      yield put(Actions.getOrganization())
      return
    }

    yield put(Actions.getMeFailure())
  } catch (err) {
    ClientNotifyCatch('Saga getMe', err)
    yield put(Actions.getMeFailure())
  }
}

export function* getOrganization() {
  try {
    const { user } = yield select((state: ApplicationState) => state.me)

    const { data, ok }: ApiResponse<ResponseDataOrganization> = yield call(
      api.get,
      `organizations/${user.organization_id}`
    )

    if (ok) {
      yield put(Actions.getOrganizationSuccess(data.organization))
      return
    }

    yield put(Actions.getOrganizationFailure())
  } catch (err) {
    ClientNotifyCatch('Saga getOrganization', err)
    yield put(Actions.getOrganizationFailure())
  }
}

export function* getPolicy() {
  try {
    const { organization } = yield select((state: ApplicationState) => state.me)

    const { data, ok }: ApiResponse<ResponseDataPolicies> = yield call(
      api.get,
      `organizations/${organization.organization_id}/users/me/policies`
    )

    if (ok) {
      yield put(Actions.getPolicySuccess(data.policies[0]))
      return
    }

    yield put(Actions.getPolicyFailure())
  } catch (err) {
    ClientNotifyCatch('Saga getPolicy', err)
    yield put(Actions.getPolicyFailure())
  }
}
